// Data-element catalog (cross-backend → admin-corev2). GET /data-elements.
// Matches admin-ui's dataElements.js `.index({params})` shape used by use-data-elements.
import { adminRequest } from './client.js';

function toQuery(params) {
	if (!params) return '';
	if (typeof params === 'string') return params ? `?${params}` : '';
	const qs = new URLSearchParams(params).toString();
	return qs ? `?${qs}` : '';
}

const api = {
	index: ({ params } = {}) => adminRequest('GET', `/data-elements${toQuery(params)}`),
};

export default api;
